// import React from 'react';
// import { Line } from 'react-konva';
// import { lineCap, strokeWidth, relatedColor, miniMapStrokeWidth } from '../../library/constants';
// import { bothPartnersDirectlyRelated } from '../../library/calc';

// const isHalfRelatedNSeparated = (halflineForRelated, isSeparated) => {
//   return (
//         typeof(halflineForRelated) !== 'undefined' &&
//         isSeparated
//   )
// }


// const Unionline = ({
//     minimap,
//     union,
//     nodeObjs,
//     start,
//     sideYPoint,
//     end,
//     isSeparated,
//     unionColor,
//     halflineForRelated,
//     stageBackgroundCustomColor,
//   }) => {

//   if(isSeparated) var dash = [1.5, 2];

//   const _sideYPoint = ( isHalfRelatedNSeparated(halflineForRelated, isSeparated) ? sideYPoint + .25 : sideYPoint);

//   const coords = [start, _sideYPoint, end, _sideYPoint];

//   let strokeColor = null;
//   if( bothPartnersDirectlyRelated(union, nodeObjs)) {
//     strokeColor = relatedColor;
//   } else{
//     strokeColor = unionColor;
//   }

//   strokeColor = typeof(stageBackgroundCustomColor) !== 'undefined' && stageBackgroundCustomColor === '#000000' ? '#FFFFFF': strokeColor;
//   // if( typeof(stageBackgroundCustomColor) !== 'undefined') console.log(`stageBackgroundCustomColor: `, stageBackgroundCustomColor);

//   if(typeof(minimap) !== 'undefined' && typeof(_sideYPoint) === 'undefined' ) {
//     console.log(`B: nodeObjs[p[0]]: `, nodeObjs[union.p[0]]);
//     console.log(`sideYPoint: `, sideYPoint);
//     console.log(`typeof(coords._sideYPoint): `, typeof(coords._sideYPoint));
//     console.log(`coords: `, JSON.stringify(coords, null, 2));
//   }

//   let stroke = isHalfRelatedNSeparated(halflineForRelated, isSeparated) ? strokeWidth / .8 :strokeWidth;

//   if(typeof(minimap) !== 'undefined') stroke = miniMapStrokeWidth;

//   return (
//     <Line
//       points = {coords}
//       stroke = {strokeColor}
//       strokeWidth = {stroke}
//       lineCap = {lineCap}
//       dash = {dash}
//       dashOffset = {0}
//       perfectDrawEnabled={false}
//       listening={false}
//     />
//   );
// };

// export default Unionline;


import React, { Component } from 'react';
import { Line } from 'react-konva';
import { lineCap, strokeWidth, relatedColor, miniMapStrokeWidth } from '../../library/constants';
import { bothPartnersDirectlyRelated } from '../../library/calc';

const isHalfRelatedNSeparated = (halflineForRelated, isSeparated) => {
  return (
        typeof(halflineForRelated) !== 'undefined' &&
        isSeparated
  )
}

class Unionline extends Component {

  componentDidUpdate(){
    this.refs.UnionlineCache.cache();
  }

  render () {

    // console.count('UnionlineCache');

    const {
      minimap,
      union,
      nodeObjs,
      start,
      sideYPoint,
      end,
      isSeparated,
      unionColor,
      halflineForRelated,
      stageBackgroundCustomColor,
    } = this.props;

    if(isSeparated) var dash = [1.5, 2];

    const _sideYPoint = ( isHalfRelatedNSeparated(halflineForRelated, isSeparated) ? sideYPoint + .25 : sideYPoint);

    const coords = [start, _sideYPoint, end, _sideYPoint];

    let strokeColor = null;
    if( bothPartnersDirectlyRelated(union, nodeObjs)) {
      strokeColor = relatedColor;
    } else{
      strokeColor = unionColor;
    }

    strokeColor = typeof(stageBackgroundCustomColor) !== 'undefined' && stageBackgroundCustomColor === '#000000' ? '#FFFFFF': strokeColor;
    // if( typeof(stageBackgroundCustomColor) !== 'undefined') console.log(`stageBackgroundCustomColor: `, stageBackgroundCustomColor);

    if(typeof(minimap) !== 'undefined' && typeof(_sideYPoint) === 'undefined' ) {
      console.log(`B: nodeObjs[p[0]]: `, nodeObjs[union.p[0]]);
      console.log(`sideYPoint: `, sideYPoint);
      console.log(`typeof(coords._sideYPoint): `, typeof(coords._sideYPoint));
      console.log(`coords: `, JSON.stringify(coords, null, 2));
    }

    let stroke = isHalfRelatedNSeparated(halflineForRelated, isSeparated) ? strokeWidth / .8 :strokeWidth;

    if(typeof(minimap) !== 'undefined') stroke = miniMapStrokeWidth;

    return (
      <Line
        ref={'UnionlineCache'}
        points = {coords}
        stroke = {strokeColor}
        strokeWidth = {stroke}
        lineCap = {lineCap}
        dash = {dash}
        dashOffset = {0}
        perfectDrawEnabled={false}
        listening={false}
      />
    );
  }
}

export default Unionline;
